<div class="icon">
  <ng-content select="[icon]"></ng-content>
</div>
<div class="texts">
  <ng-content select="[title]"></ng-content>
  <ng-content select="[description]"></ng-content>
</div>
